/**
 * Функция для поиска текста с юникод флагом и игнорированием кейса символа
 * 
 * @param {*} mainText - целевой текстпо которому будет происходить поиск
 * @param {*} searchText - текст для поиска в целевом тексте
 * @returns 
 */
export const unicodeCaseInsensitiveSearch = (mainText, searchText) => {
    // Экранируем специальные символы
    const escapedSearch = searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(escapedSearch, 'iu'); // 'i' - ignore case, 'u' - unicode
    return regex.test(mainText);
}
